// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.requirements-modal-container .cald-modal-body .reqs-table tr th {
  font-family: "72-Regular";
}

.requirements-modal {
  width: 39.6rem !important;
}
.requirements-modal .modal-content {
  width: 100% !important;
}

.requirements-modal-container .no-rules-text {
  background-color: #f2fbfe;
}
.requirements-modal-container .modal-content {
  width: 100% !important;
}
.requirements-modal-container .cald-modal-body {
  max-height: 30rem;
  overflow: auto;
}
.requirements-modal-container .cald-modal-body .reqs-table tr th {
  font-size: 1.2rem;
  color: #6a6d70;
  padding: 0;
  padding-bottom: 0 !important;
  font-weight: normal;
}
.requirements-modal-container .cald-modal-body .reqs-table tr th, .requirements-modal-container .cald-modal-body .reqs-table tr td {
  border: none;
  padding: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/requirements-modal/requirements-modal.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAqBA;EACI,yBAAA;ACvBJ;;AADA;EACE,yBAAA;AAIF;AAFE;EACI,sBAAA;AAIN;;AAEE;EACE,yBAAA;AACJ;AAEI;EACI,sBAAA;AAAR;AAGE;EACE,iBAAA;EACA,cAAA;AADJ;AAIQ;EACE,iBAAA;EACA,cAAA;EACA,UAAA;EAEA,4BAAA;EACA,mBAAA;AAHV;AAKQ;EACE,YAAA;EACA,eAAA;AAHV","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n\n.requirements-modal {\n  width: 39.6rem !important;\n    \n  .modal-content{\n      width: 100% !important;\n  }\n}\n\n.requirements-modal-container {\n\n  .no-rules-text{\n    background-color: #f2fbfe;\n  }\n    // width: 48rem !important;\n    .modal-content{\n        width: 100% !important;\n    }\n\n  .cald-modal-body{\n    max-height: 30rem;\n    overflow: auto;\n    .reqs-table{\n      tr{\n        th{\n          font-size: 1.2rem;\n          color: #6a6d70;\n          padding: 0;\n          @extend %font-regular;\n          padding-bottom: 0 !important;\n          font-weight: normal;\n        }\n        th, td{\n          border: none;\n          padding: 0.5rem;\n        }\n      }\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
